import { Button } from '@/shared/components/ui/button';

interface DangerZoneProps {
  title: string;
  description: string;
  actionTitle: string;
  actionDescription: string;
  buttonLabel: string;
  onAction: () => void;
  testId?: string;
  buttonTestId?: string;
}

export function DangerZone({
  title,
  description,
  actionTitle,
  actionDescription,
  buttonLabel,
  onAction,
  testId,
  buttonTestId,
}: DangerZoneProps) {
  return (
    <div className="py-10" data-testid={testId}>
      <div className="rounded-lg border border-destructive/40 overflow-hidden">
        <div className="px-6 py-4 border-b border-destructive/30 bg-destructive/5">
          <h3 className="text-sm font-semibold text-destructive">{title}</h3>
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        </div>
        <div className="px-6 py-4 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="space-y-1">
            <p className="text-sm font-medium text-foreground">{actionTitle}</p>
            <p className="text-sm text-muted-foreground">{actionDescription}</p>
          </div>
          <Button
            type="button"
            variant="destructive"
            onClick={onAction}
            data-testid={buttonTestId}
            className="shrink-0"
          >
            {buttonLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
